import { SelectItem } from 'primeng/api';

export enum EstimateStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  PendingApproval = 'READY_FOR_APPROVAL',
  InProgress = 'IN_PROGRESS',
  Expired = 'EXPIRED',
  CCA = 'CCA',
  OnHold = 'ON_HOLD',
}

export const ESTIMATE_STATUSES: SelectItem[] = [
  { label: 'Approved', value: EstimateStatus.Approved },
  { label: 'Declined', value: EstimateStatus.Declined },
  { label: 'Ready', value: EstimateStatus.PendingApproval },
  { label: 'In Progress', value: EstimateStatus.InProgress },
  { label: 'Expired', value: EstimateStatus.Expired },
  { label: 'CCA', value: EstimateStatus.CCA },
  { label: 'On Hold', value: EstimateStatus.OnHold },
];
